import dayjs, { type Dayjs } from "dayjs"

type DateRangeValue = string | Date | Dayjs

const defaultToday = dayjs()

// 預設資料時間區間
export default function useInitDateRange(
    start: DateRangeValue,
    end: DateRangeValue,
    today: DateRangeValue = defaultToday,
    base = 2
): string[] {
    today = initialDate(today)
    const baseDay = today.subtract(base, "day")
    const endDate = dayjs(end)
    const startDate = dayjs(start)

    // 如果結束時間在基準日之後，使用基準日
    const finalEndDate = dayjs(endDate).isAfter(baseDay) ? baseDay : endDate

    return [startDate, finalDate(finalEndDate)].map((d) => d.toISOString())
}

// 取得當天起點 (00:00:00 000)
export function initialDate(day: DateRangeValue): Dayjs {
    return dayjs(day).set("hour", 0).set("minute", 0).set("second", 0).set("millisecond", 0)
}

// 取得當天終點 (23:59:59 999)
export function finalDate(day: DateRangeValue): Dayjs {
    return dayjs(day).set("hour", 23).set("minute", 59).set("second", 59).set("millisecond", 999)
}
